import styled from "styled-components";

export const ListContainer = styled.ul``;

export const ListItemContainer = styled.li``;
